import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  HostBinding,
} from '@angular/core';

import { BaseInputComponent } from '../../../common/base-input.component';
import { IRadioGroup } from './radio-group.interface';

@Component({
  selector: 'nibtravel-radio-group',
  templateUrl: './radio-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioGroupComponent extends BaseInputComponent {
  @Input() radioGroup!: IRadioGroup | undefined;
  // eslint-disable-next-line @angular-eslint/no-output-rename
  @Output('checked') valueChange = new EventEmitter();

  @HostBinding('class') class = 'radio';

  /**
   * Write form value to the DOM element (model => view)
   */
  writeValue(value: any): void {
    if (this.radioGroup && this.radioGroup.data) {
      this.radioGroup.data.forEach((r) => {
        return (r.checked = r.value === value);
      });
    }

    super.writeValue(value);
  }
}
